<ng-container *ngIf="this.selectedItem">

  <h1 mat-dialog-title style="display: flex; justify-content: space-between;">
    {{ this.selectedItem?.flow.Description }} - Anteprima
    <span>{{this.currentIndex + 1}}/{{this.items.length}}</span>
  </h1>

  <div mat-dialog-content>

    <div class="pdf-modal">

      <button class="nav-button left" (click)="prevFile()"><mat-icon>arrow_back_ios</mat-icon></button>
      <iframe #iframe></iframe>
      <button class="nav-button right" (click)="nextFile()"><mat-icon>arrow_forward_ios</mat-icon></button>

    </div>

  </div>

  <div mat-dialog-actions class="d-flex space-between">

    <button mat-raised-button color="warn" [mat-dialog-close]="false">
      <mat-icon>close</mat-icon>
      Chiudi
    </button>

    <ng-container>
    
      <mat-checkbox
        [checked]="confirmedDocuments.get(selectedItem.flow.Oid) || false"
        (change)="toggleConfirmation()">
        Approva documento
      </mat-checkbox>

      <button mat-raised-button color="primary" [disabled]="activateSubmit == false" (click)="submit()">
        Conferma approvazioni
      </button>

      <button mat-raised-button color="primary" (click)="approveAll()">
        Approva tutti
        <mat-icon>arrow_forward</mat-icon>
      </button>

    </ng-container>

  </div>

</ng-container>
